/**
 * @generated SignedSource<<4e71f4bb6f14e24c6c71fe19f9bbed1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactSellerButton_refactor_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "PdpSharedContactSellerButton_refactor_user";
};
export type PdpSharedContactSellerButton_refactor_user$key = {
  readonly " $data"?: PdpSharedContactSellerButton_refactor_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_refactor_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactSellerButton_refactor_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d94a30b422934debcd2acf4b390a7a5e";

export default node;
